import theme from 'theme';

export const displayFlexAlignCenter = {
  display: 'flex',
  alignItems: 'center',
};

export const flexCenter = {
  justifyContent: 'center',
  ...displayFlexAlignCenter,
};

export const flexCenterJustifyBetween = {
  ...displayFlexAlignCenter,
  justifyContent: 'space-between',
};

export const flexJustifyBetween = {
  ...displayFlexAlignCenter,
  justifyContent: 'space-between',
};

export const flexEnd = {
  ...displayFlexAlignCenter,
  justifyContent: 'flex-end',
};

export const flexDirectionColumn = {
  display: 'flex',
  flexDirection: 'column',
};

export const flexTextCenterColumn = {
  ...flexDirectionColumn,
  textAlign: 'center',
  justifyContent: 'center',
};

export const flexStart = {
  display: 'flex',
  alignItems: 'start',
};

export const flexStartJustifyBetween = {
  ...flexStart,
  justifyContent: 'space-between',
};

export const flexCenterJustifyEnd = {
  ...flexCenter,
  justifyContent: 'end',
};

export const flexColCenter = {
  ...flexDirectionColumn,
  ...flexCenter,
};

export const borderTop = { borderTop: `1px solid ${theme.palette.divider}` };

export const cardContentBoxSx = {
  flex: 1,
  p: 2,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
} as const;
export const textTruncate = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '110px',
};
